import { connect } from 'react-redux';

import PipedriveConfigurationView from './PipedriveConfigurationView.jsx';
import { updateConfiguration} from 'src/legacy/redux/actions/integrations/pipedrive.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.pipedrive.changes.error,
    updating: state.legacyRootReducer.settings.integrations.pipedrive.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.pipedrive.changes.loading,
    user: state.users.me,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    }
  }
}

const PipedriveConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(PipedriveConfigurationView);

export default PipedriveConfigurationPage;
